import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

// Checklist plano OK/FALLA/NA por ítem. Alinea su semántica con el átomo
// `TriState` del editor mobile del técnico. Los colores semánticos de estado
// (verde/rojo) transmiten significado, no tema — el muted/label sí salen del
// token del tenant (regla: no #666 hardcoded para colores de tema).
const STATE = {
  OK: { symbol: '✓', color: '#2e7d32' }, // ✓
  FALLA: { symbol: '✗', color: '#c62828' }, // ✗
  NA: { symbol: '—', color: null }, // — (usa colors.muted)
};

function ChecklistSection({ section }) {
  const { colors, baseStyles, FONT } = useTemplateColors();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        container: { display: 'flex', flexDirection: 'column' },
        row: {
          flexDirection: 'row',
          gap: '0.2cm',
          marginBottom: '0.15cm',
          alignItems: 'flex-start',
        },
        symbol: { width: 14, fontSize: 11, fontFamily: FONT.bold },
        content: { flex: 1, display: 'flex', flexDirection: 'column' },
        label: { fontSize: 10, fontFamily: FONT.base, color: colors.darkText },
        nota: { fontSize: 8, fontFamily: FONT.base, color: colors.muted, marginTop: '0.05cm' },
      }),
    [colors, FONT]
  );

  const items = Array.isArray(section?.config?.items) ? section.config.items : [];
  if (items.length === 0) return null;

  return (
    <View style={styles.container} wrap={false}>
      {section?.title ? <Text style={baseStyles.sectionTitle}>{section.title}</Text> : null}
      {items.map((item, i) => {
        const st = STATE[item?.estado] || STATE.NA;
        return (
          <View key={i} style={styles.row}>
            <Text style={[styles.symbol, { color: st.color || colors.muted }]}>{st.symbol}</Text>
            <View style={styles.content}>
              <Text style={styles.label}>{item?.label || '—'}</Text>
              {item?.nota ? <Text style={styles.nota}>{item.nota}</Text> : null}
            </View>
          </View>
        );
      })}
    </View>
  );
}

export default ChecklistSection;
